import { createRoot } from 'react-dom/client';
import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge';
import './index.css';
import './config/agCharts';
import App from './App.tsx';
import msalInstance from './config/msalInstance';
import { registerStaleBuildRecovery } from './utils/staleBuildRecovery';

// To renew a token silently MSAL loads the redirect URI ("/") in a hidden iframe, and MSAL v5 waits
// for that page to hand the response back to the main window. So in that iframe only do that: booting
// the whole app there makes MSAL throw block_iframe_reload and the renewal time out.
const isSilentAuthFrame =
	window.parent !== window && /(^|[#?&])(code|error)=/.test(`${window.location.hash}&${window.location.search}`);

if (isSilentAuthFrame) {
	broadcastResponseToMainFrame().catch((error) => console.error('[auth] Could not hand the token back:', error));
} else {
	registerStaleBuildRecovery();

	msalInstance.initialize().then(() => {
		createRoot(document.getElementById('root')!).render(<App />);
	});
}
